import Axios from 'axios'
import config from '@/config/config.js'

const API_VERSION = '1.0.1'
const baseUrl = `${config.apiDomain.BOARDWARE_WORKFLOW}api/${API_VERSION}/pn/wf/instance/`
const downloadFileUrl = `${config.apiDomain.BOARDWARE_WORKFLOW}api/${API_VERSION}/pn/wf/download_work_item?doc_code=`

Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {
  downloadFileUrl,
  buildGetItemQuery (pageNum, pageSize, keyword) {
    let query = ''
    if (pageNum || pageSize || keyword) {
      if (pageNum) query = query + (query ? '&' : '') + 'page_num=' + pageNum
      if (pageSize) query = query + (query ? '&' : '') + 'page_size=' + pageSize
      if (keyword) query = query + (query ? '&' : '') + 'keyword=' + keyword
      query = '?' + query
    }
    return query
  },
  getPersonalActiveItems (cb, businessCode, pageNum, pageSize, keyword) {
    let query = this.buildGetItemQuery(pageNum, pageSize, keyword)
    Axios.get(baseUrl + businessCode + '/personal/active' + query).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getFollowingActiveItems (cb, businessCode, euid, pageNum, pageSize, keyword) {
    let query = this.buildGetItemQuery(pageNum, pageSize, keyword)
    Axios.get(baseUrl + businessCode + '/following/' + euid + '/active' + query).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getPersonalHistoryItems (cb, businessCode, pageNum, pageSize, keyword) {
    let query = this.buildGetItemQuery(pageNum, pageSize, keyword)
    Axios.get(baseUrl + businessCode + '/personal/done' + query).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getFollowingHistoryItems (cb, businessCode, euid, pageNum, pageSize, keyword) {
    let query = this.buildGetItemQuery(pageNum, pageSize, keyword)
    Axios.get(baseUrl + businessCode + '/following/' + euid + '/done' + query).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getHistoryList (cb, businessCode, recordId) {
    Axios.get(baseUrl + businessCode + '/' + recordId + '/history').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  flow (cb, item, work) {
    let body = {
      instance: {
        instance_version: item.version
      },
      work
    }
    Axios.post(baseUrl + item.biz_code + '/' + item.record_id, body).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getAllCounts (cb) {
    Axios.get(baseUrl + 'counts').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  removeFromCart (cb, bizCode, recordId) {
    Axios.delete(`${config.apiDomain.BOARDWARE_WORKFLOW}api/${API_VERSION}/pn/wf/carts/${bizCode}/${recordId}`).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  removeFromCartBatch (cb, objs) {
    let body = []
    objs.forEach(obj => {
      body.push({
        biz_code: obj.bizCode,
        record_id: obj.recordId

      })
    })
    Axios.delete(`${config.apiDomain.BOARDWARE_WORKFLOW}api/${API_VERSION}/pn/wf/batch_carts`, body).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  addToCart (cb, task, work) {
    let body = {
      instance: {
        biz_code: task.biz_code,
        record_id: task.record_id,
        instance_version: task.version
      },
      work
    }
    Axios.post(`${config.apiDomain.BOARDWARE_WORKFLOW}api/${API_VERSION}/pn/wf/carts`, body).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  addToCartBatch (cb, taskObjs) {
    let body = []
    taskObjs.forEach(obj => {
      body.push({
        instance: {
          biz_code: obj.task.biz_code,
          record_id: obj.task.record_id,
          instance_version: obj.task.version
        },
        work: obj.work
      })
    })
    Axios.post(`${config.apiDomain.BOARDWARE_WORKFLOW}api/${API_VERSION}/pn/wf/batch_carts`, body).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getSignLink (cb, redirectUri, signType, bizCode) {
    let body = {
      redirect_uri: redirectUri,
      sign_type: signType,
      sign_entries: {
        biz_code: bizCode
      }
    }
    Axios.post(baseUrl + 'sign_entry', body).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  batchSign (cb, code, bizCode) {
    let body = {
      code: code,
      sign_entries: {
        biz_code: bizCode
      }
    }
    return new Promise((resolve, reject) => {
      Axios.post(baseUrl + 'batch_sign', body).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.log(error)
          cb(error.response)
        }
      )
    })
  },

  getCartByBatchNo (cb, batchNo) {
    Axios.get(`${config.apiDomain.BOARDWARE_WORKFLOW}api/${API_VERSION}/pn/wf/carts?batch_no=${batchNo}`).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getFollowingStaffsByBusinessCode (cb, businessCode) {
    Axios.get(`${config.apiDomain.BOARDWARE_WORKFLOW}api/${API_VERSION}/pn/wf/instance/${businessCode}/followings`).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  }
}
